import { useCallback } from 'react';
import { v4 as uuidv4 } from 'uuid';
import type { UnSignedSignatureBox, SignatureBox } from 'services/entities/SignatureTypes';
import { useAppDispatch } from '../grid/reduxStore/Store';
import { useSocketClient } from '../../../providers/SocketContext';
import { useCurrentUser } from '../../../providers/UserProvider';
import { useCheckDocumentLockStatus } from 'components/editor/hooks/useCheckDocumentLockStatus';
import { UndoRedoManagerCommandVersion } from '../UndoRedo/UndoRedoManagerCommandVersion';
import { SignatureInsertCommand } from '../UndoRedo/SignatureInsertCommand';

export function useSignatureInsertHandler() {
  const dispatch = useAppDispatch();
  const { socketClient } = useSocketClient();
  const { data } = useCurrentUser();
  const userId = data.id;
  const checkDocumentLockStatus = useCheckDocumentLockStatus();

  return useCallback(
    (sectionId: string, signature: UnSignedSignatureBox): string => {
      const signatureId = uuidv4();
      const signatureWithId = {
        ...signature,
        signatureBoxId: signatureId,
      } as SignatureBox;

      const command = new SignatureInsertCommand(
        { dispatch, socketClient, userId, checkDocumentLockStatus },
        { sectionId, signature: signatureWithId }
      );

      command.applyOptimistic();

      const undoRedoManager = UndoRedoManagerCommandVersion.getUndoRedoManager();
      undoRedoManager.pushUndoRedoCommands(command);

      command.persistToSocket().then((success) => {
        if (!success) {
          console.error('useSignatureInsertHandler: socket persist failed, state was rolled back');
          undoRedoManager.clearBlockCommands(signatureId);
        }
      });

      return signatureId;
    },
    [dispatch, socketClient, userId, checkDocumentLockStatus]
  );
}
